const bannerImage =
  'https://res.cloudinary.com/dwoubdppz/image/upload/w_800,q_auto,f_auto/v1751597877/oak-and-stone-remodel/kitchen/kitchen5.webp';

export const LandingBanner = () => {
  return (
    <div className="relative w-full min-h-[400px] sm:min-h-[450px] md:min-h-[500px] flex items-center">
      {/* Background Image with Simple Overlay */}
      <div className="absolute inset-0">
        <img
          src={bannerImage}
          alt="Oak and Stone Construction craftsmanship"
          className="object-cover w-full h-full"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black bg-opacity-40"></div>
      </div>

      {/* Content */}
      <div className="relative px-4 sm:px-6 py-16 sm:py-20 w-full">
        <div className="mx-auto max-w-[1200px] text-center space-y-6 sm:space-y-8">
          <h2 className="text-xl sm:text-2xl font-medium tracking-widest text-white uppercase md:text-3xl">
            we follow the golden rule... <br className="hidden sm:block" />
            we treat your home as if it were our own
          </h2>

          <div className="h-[2px] w-24 sm:w-32 bg-blue-500 mx-auto"></div>

          <p className="max-w-[1200px] mx-auto text-base sm:text-lg leading-relaxed text-white/90">
            Oak and Stone Construction is a licensed and insured residential
            contractor offering comprehensive interior and exterior remodeling
            services. We specialize in kitchen renovations, custom cabinetry,
            bathroom remodels, and complete home transformations.
          </p>
        </div>
      </div>
    </div>
  );
};
